var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property } from 'lit-element';
import '../material-dialog';
let TerminalDialogElement = class TerminalDialogElement extends LitElement {
    render() {
        return html `
      <material-dialog title="${this.title}" .content=${this.getContent()} ></material-dialog>
    `;
    }
    getContent() {
        if (Object.keys(this.data).length == 0) {
            return 'No additional info available';
        }
        else {
            return html `
        ${Object.keys(this.data).sort().map(key => html `<b>${key}</b>: ${this.data[key]}<br>`)}
      `;
        }
    }
};
__decorate([
    property()
], TerminalDialogElement.prototype, "title", void 0);
__decorate([
    property()
], TerminalDialogElement.prototype, "data", void 0);
TerminalDialogElement = __decorate([
    customElement('terminal-dialog')
], TerminalDialogElement);
